import { render, staticRenderFns } from "./ZohoChannelDetail.vue?vue&type=template&id=09e3cb0c&scoped=true"
import script from "./ZohoChannelDetail.vue?vue&type=script&lang=js"
export * from "./ZohoChannelDetail.vue?vue&type=script&lang=js"
import style0 from "./ZohoChannelDetail.vue?vue&type=style&index=0&id=09e3cb0c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09e3cb0c",
  null
  
)

export default component.exports